import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const patentProofApi = generateProofApi('/proof-file/patent');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('patent', patentProofApi);

export function getPatentProofsByOwnerOptions(patentId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(patentId, userId);
}

export function getPatentProofsOptions(patentId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(patentId);
}

export function useUploadOrUpdatePatentProof(patentId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(patentId, queryClient));
}

export function useDeletePatentProof(patentId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(patentId, queryClient));
}
